'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const components_display_Icon_Icon = require('../Icon/Icon.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1hmz0_1";
const container = "_container_1hmz0_70";
const statusIcon = "_status-icon_1hmz0_75";
const title = "_title_1hmz0_102";
const closeButton = "_close-button_1hmz0_113";
const styles = {
	root: root,
	container: container,
	statusIcon: statusIcon,
	title: title,
	closeButton: closeButton
};

const STATUS_ICONS = {
  info: "alertInfoFill",
  success: "formCheckCircle",
  warning: "alertCircleColor",
  error: "formXCircle"
};
const Alert = (_a) => {
  var { children = void 0, onDismiss = void 0, role = void 0, status = "info", title = void 0, variant = "alert" } = _a, props = tslib_es6.__rest(_a, ["children", "onDismiss", "role", "status", "title", "variant"]);
  const closeButton = onDismiss && React__default.default.createElement(
    "button",
    { type: "button", "aria-label": "Dismiss", className: styles.closeButton, onClick: onDismiss, "data-zds": true },
    React__default.default.createElement(components_display_Icon_Icon.Icon, { isBlock: true, name: "formX", size: 24 })
  );
  return React__default.default.createElement(
    "article",
    { "aria-live": props["aria-live"], className: styles.root, "data-status": status, role, "data-variant": variant, "data-zds": true },
    React__default.default.createElement(
      "div",
      { className: styles.statusIcon, "data-status": status, "data-variant": variant, "data-zds": true },
      React__default.default.createElement(components_display_Icon_Icon.Icon, { "aria-label": status, isBlock: true, name: STATUS_ICONS[status] || "alertInfoFill", size: variant === "compact" ? 20 : 24 })
    ),
    React__default.default.createElement(
      "div",
      { className: styles.container, "data-zds": true },
      title && React__default.default.createElement("h2", { className: styles.title, "data-variant": variant, "data-zds": true }, title),
      children
    ),
    closeButton
  );
};

exports.Alert = Alert;
//# sourceMappingURL=Alert.cjs.js.map
